module.exports = __webpack_public_path__ + "img/edit-in-cms.bbb97783.svg";